"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptForm = void 0;
var react_1 = __importDefault(require("react"));
var PostAcceptRedirect_1 = require("@CommonFrontendBackend/Accept/PostAcceptRedirect");
var ReactAcceptFlow_1 = require("Project/Modules/Accept/ReactAcceptFlow");
var inversify_react_1 = require("inversify-react");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var Utils_1 = require("@CommonFrontend/AgreementView/Utils");
var AcceptForm = function (_a) {
    var onCloseModal = _a.onCloseModal, isStripeIntegrationEnabled = _a.isStripeIntegrationEnabled, stripePublicKey = _a.stripePublicKey, acceptBlockSettings = _a.acceptBlockSettings, customisation = _a.customisation;
    var project = (0, inversify_react_1.useInjection)("project");
    var telemetry = (0, inversify_react_1.useInjection)("telemetry");
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var settings = customisation ? (0, Utils_1.mergeAgreementOverrides)(acceptBlockSettings, customisation) : acceptBlockSettings;
    return (react_1.default.createElement(ReactAcceptFlow_1.ReactAcceptFlow, { isSimpleMode: true, onClose: onCloseModal, isPreviewAccept: true, stripePublicKey: stripePublicKey, optOutSpringboard: usingFeature(FeatureFlag_1.default.OptOutSpringboardEngagementMenu), isStripeIntegrationEnabled: isStripeIntegrationEnabled, autofillEnabled: true, postAcceptRedirectUrl: (0, PostAcceptRedirect_1.getFinalRedirectURL)(acceptBlockSettings.postAcceptance.url, {
            pageId: project._id,
            preview: true,
        }), isPrintMode: false, telemetry: telemetry, settings: settings, autoScrollIntoView: false, requiresQuoteChoice: false }));
};
exports.AcceptForm = AcceptForm;
